import React, { useEffect, useState } from "react";
import "./Animations/Animations.css";

const sshSteps = [
  "user@local:~$ ssh noor@portfolio",
  "Connecting to portfolio.joomun.com...",
  "Authenticating...",
  "Authentication successful.",
  "Establishing secure connection...",
  "Welcome to Noor's Portfolio Terminal!",
  "Tip: Light terminals attract more bugs 🐞",
];

function Pre({ load, onFinish }) {
  const [step, setStep] = useState(0);
  const [done, setDone] = useState(false);

  useEffect(() => {
    if (load) {
      setStep(0);
      setDone(false);
      const interval = setInterval(() => {
        setStep((prev) => {
          if (prev < sshSteps.length - 1) {
            return prev + 1;
          } else {
            clearInterval(interval);
            setDone(true);
            // Optionally notify parent after animation is done
            if (onFinish) onFinish();
            return prev;
          }
        });
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [load, onFinish]);

  // Only show loader until all steps are shown
  const showLoader = load && !done;

  return (
    <div id={showLoader ? "preloader" : "preloader-none"}>
      {showLoader && (
        <div className="terminal-loader">
          <div className="terminal-header">
            <span className="terminal-dot red"></span>
            <span className="terminal-dot yellow"></span>
            <span className="terminal-dot green"></span>
            <span className="terminal-title">noor@portfolio:~$</span>
          </div>
          <div className="terminal-body">
            {sshSteps.slice(0, step + 1).map((line, idx) => {
              const lineColor =
                idx === 0
                  ? "var(--terminal-green)"
                  : idx === sshSteps.length - 1
                  ? "var(--terminal-purple)"
                  : "var(--text-secondary)";

              return (
                <div
                  key={idx}
                  className={`terminal-line${idx === sshSteps.length - 1 ? " terminal-joke" : ""}`}
                  style={{
                    color: lineColor,
                    fontFamily: "'Fira Code', monospace",
                    marginBottom: "6px",
                    fontSize: "1.1em",
                  }}
                >
                  {line}
                  {idx === step && step < sshSteps.length - 1 && (
                    <span className="terminal-cursor">█</span>
                  )}
                </div>
              );
            })}
            <div className="terminal-loading-bar">
              <span className="loading-bar"></span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Pre;
